import { useState } from "react";
import { Button, FormControl, FormLabel, Input, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useClaimCreditMutation } from "../hooks/useSettingsMutations";

export function CreditsSection() {
  const [t] = useTranslation();
  const [token, setToken] = useState("");
  const { mutate, isPending } = useClaimCreditMutation();

  const handleClaim = () => {
    if (token.trim()) {
      mutate(token.trim(), {
        onSuccess: () => setToken(""),
      });
    }
  };

  return (
    <VStack spacing={5} align="stretch">
      <Text fontSize="xl" fontFamily="heading" fontWeight={600} color="dune.dune">
        {t("screens.settings.creditsPromoCodes")}
      </Text>

      <FormControl>
        <FormLabel fontSize="sm" color="transparent.white.60">
          {t("screens.settings.enterPromoCode")}
        </FormLabel>
        <Input
          fontSize="16px"
          value={token}
          onChange={(e) => setToken(e.target.value.toUpperCase())}
          placeholder={t("screens.settings.promoPlaceholder")}
          maxLength={64}
        />
        <Text fontSize="xs" color="transparent.white.40" mt={1}>
          {t("screens.settings.promoHint")}
        </Text>
      </FormControl>

      <Button
        variant="primary"
        size="sm"
        onClick={handleClaim}
        isLoading={isPending}
        isDisabled={!token.trim() || isPending}
      >
        {t("screens.settings.claimCode")}
      </Button>
    </VStack>
  );
}
